import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';

@Component({
  selector: 'app-validation-container',
  templateUrl: './validation-container.component.html',
  styleUrls: ['./validation-container.component.scss'],
})
export class ValidationContainerComponent implements OnChanges {
  errorMessages: any[];
  warningMessages: any[];
  infoMessages: any[];

  @Input() messages: any[];

  ngOnChanges(changes: SimpleChanges) {
    if (changes.messages && changes.messages.currentValue) {
      this.errorMessages = changes.messages.currentValue.filter(
        m => !!m.type && m.type.toLowerCase().indexOf('exception') !== -1,
      );
      this.warningMessages = changes.messages.currentValue.filter(
        m => !!m.type && m.type.toLowerCase() === 'warning',
      );
      this.infoMessages = changes.messages.currentValue.filter(
        m => !!m.type && m.type.toLowerCase() === 'info',
      );
    }
  }
}
